import { useContext } from 'react';
import { AuthDataProvider } from 'src/components/authProvider';
import { PATHS } from 'src/constants/paths';
import { AuthClassification } from 'src/hooks/auth/auth.interface';

interface GetLocationsPathOptions {
  preferUnassigned?: boolean;
}

export const useUserRole = () => {
  const { userRole } = useContext(AuthDataProvider);

  const isViewOnly = userRole === AuthClassification.VIEWER;
  const isOwnerOperator = userRole === AuthClassification.OWNER_OPERATOR;
  const isContentCreator = userRole === AuthClassification.CONTENT_CREATOR;
  const isAdmin = userRole === AuthClassification.ADMINISTRATOR;

  const getLocationsPath = (options?: GetLocationsPathOptions): string => {
    if (isOwnerOperator) {
      return PATHS.OO_LOCATION_PAGE;
    }
    if (options?.preferUnassigned) {
      return PATHS.UNASSIGNED_LOCATIONS;
    }

    return PATHS.LOCATIONS;
  };

  return {
    isViewOnly,
    isOwnerOperator,
    isContentCreator,
    isAdmin,
    getLocationsPath,
  };
};
